export default function toggleMobileMenu() {
    const header = document.querySelector('#site-header');
    if (!header) {
        return;
    }
    const toggler = header.querySelector('.js-menu-btn');
    if (!toggler) {
        return;
    }
    const menu = document.querySelector('.js--menu');
    toggler.addEventListener('click', () => {
        toggler.classList.toggle('open');
        menu === null || menu === void 0 ? void 0 : menu.classList.toggle('active');
    });
}
